import { BASE_URL } from '../config/config'
import { builder } from '../utils/queryBuilder'
import Fetch from './Fetch'

export const getAllOrders = async (body) => {
  const params = builder({
    name: body.name,
    take: body.take,
    skip: body.skip,
    status: body.status,
    created_at: body.created_at,
  })
  return await Fetch.get(`${BASE_URL}order/admin${params}`)
}

// get a order by admin-------------
export const getAOrderByAdmin = (id) => Fetch.get(`${BASE_URL}order/admin/${id}`)

export const getAllOrdersToPrint = async (body) => {
  const params = builder({
    name: body.name,
    status: body.status,
    created_at: body.created_at,
  })
  return await Fetch.get(`${BASE_URL}order/admin${params}`)
}

export const addNewOrderByAdmin = (body) => Fetch.post(`${BASE_URL}order/admin`, body)

export const updateOrderByAdmin = (id, body) => Fetch.patch(`${BASE_URL}order/admin/${id}`, body)

// -------------- PROCESS OF ORDER
export const addNewProcess = (body) => Fetch.post(`${BASE_URL}process/admin`, body)

export const updateAProcess = (id, body) => Fetch.patch(`${BASE_URL}process/admin/${id}`, body)

export const deleteAProcess = (id) => Fetch.delete(`${BASE_URL}process/admin/${id}`)

export const getAllProcessOfOrder = (body) => {
  const params = builder({
    take: body.take,
    skip: body.skip,
  })
  return Fetch.get(`${BASE_URL}process/admin/${body.id}${params}`)
}

export const deleteAOrderByAdmin = (id) => Fetch.delete(`${BASE_URL}order/admin/${id}`)

//get a process of or order by admin
export const getAOrderProcessByAdmin = (id, body) =>
  Fetch.get(`${BASE_URL}process/admin/${id}`, body)
